import { makeStyles, withStyles } from '@material-ui/core/styles';
import { MenuItem } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  flagOnly: {
    minWidth: 'unset',
    padding: '0 0 0 5px',
    '&:focus': {
      backgroundColor: theme.palette.tertiary.mediumGrey,
    },
  },
  flag: {
    fontSize: '1.5rem',
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
  },
  flagIcon: {
    width: '24px',
    height: '16px',
    marginRight: '8px',
  },
}));

export const CustomMenuItem = withStyles((theme) => ({
  root: {
    '&:hover': {
      backgroundColor: theme.palette.tertiary.mediumGrey,
    },
    '&$selected': {
      backgroundColor: theme.palette.tertiary.mediumGrey,
    },
    '&$selected:hover': {
      backgroundColor: theme.palette.tertiary.mediumGrey,
    },
    '& > span': {
      marginRight: '1rem',
    },
  },
  selected: {},
}))(MenuItem);
